import FadeInSection from '../../../components/feature/FadeInSection';

const LINE_URL = 'https://lin.ee/PNbhQI0';

export default function ContactMethodsSection() {
  return (
    <section className="section-padding" style={{ background: '#fff8f2' }}>
      <div className="content-width">
        <FadeInSection className="text-center mb-14">
          <p
            className="inline-block px-4 py-1 rounded-full text-sm font-bold mb-4"
            style={{ background: 'rgba(232,147,78,0.12)', color: '#e8934e' }}
          >
            3つのご連絡方法
          </p>
          <h2 style={{ color: '#8b4513' }}>ご都合のよい方法でご連絡ください</h2>
          <p className="mt-4 mx-auto max-w-xl" style={{ color: '#6b5a4e', fontSize: '17px', lineHeight: '1.8' }}>
            お電話・LINE・メールフォームから<br className="hidden sm:block" />
            お選びいただけます。
          </p>
        </FadeInSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Phone */}
          <FadeInSection delay={0}>
            <a
              href="tel:03-4500-8399"
              className="flex flex-col items-center p-10 rounded-2xl text-center cursor-pointer transition-transform hover:scale-[1.03] h-full"
              style={{
                background: '#fff',
                border: '2px solid rgba(232,147,78,0.3)',
              }}
            >
              <div
                className="mb-6 flex items-center justify-center w-20 h-20 rounded-full"
                style={{ background: '#fff8f2' }}
              >
                <span className="flex items-center justify-center w-11 h-11">
                  <i className="ri-phone-fill text-[#e8934e] text-4xl"></i>
                </span>
              </div>
              <h3 style={{ color: '#8b4513', fontSize: '20px', marginBottom: '16px' }}>
                お電話でのご相談
              </h3>
              <p
                style={{
                  color: '#e8934e',
                  fontSize: '30px',
                  fontWeight: '800',
                  letterSpacing: '0.04em',
                  lineHeight: '1.3',
                }}
              >
                03-4500-8399
              </p>
              <p
                className="mt-3 px-4 py-1 rounded-full"
                style={{ background: '#fff8f2', color: '#8b4513', fontSize: '14px', fontWeight: '600' }}
              >
                受付時間 10:00〜18:00
              </p>
              <p className="mt-4" style={{ color: '#6b5a4e', fontSize: '15px', lineHeight: '1.8' }}>
                直接お話いただけます。<br />
                どんなご質問もお気軽にどうぞ。
              </p>
            </a>
          </FadeInSection>

          {/* LINE */}
          <FadeInSection delay={120}>
            <a
              href={LINE_URL}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex flex-col items-center p-10 rounded-2xl text-center cursor-pointer transition-transform hover:scale-[1.03] h-full"
              style={{
                background: '#fff',
                border: '2px solid rgba(6,199,85,0.3)',
              }}
            >
              <div
                className="mb-6 flex items-center justify-center w-20 h-20 rounded-full"
                style={{ background: '#f0fdf4' }}
              >
                <span className="flex items-center justify-center w-11 h-11">
                  <i className="ri-line-fill text-[#06C755] text-4xl"></i>
                </span>
              </div>
              <h3 style={{ color: '#8b4513', fontSize: '20px', marginBottom: '16px' }}>
                LINEで相談する
              </h3>
              <span
                className="inline-block px-6 py-3 rounded-full font-bold"
                style={{
                  background: '#06C755',
                  color: '#fff',
                  fontSize: '18px',
                }}
              >
                LINE友だち追加
              </span>
              <p className="mt-4" style={{ color: '#6b5a4e', fontSize: '15px', lineHeight: '1.8' }}>
                チャット感覚でご相談いただけます。<br />
                返信はできる限り早くお送りします。
              </p>
            </a>
          </FadeInSection>

          {/* Form */}
          <FadeInSection delay={240}>
            <a
              href="#contact-form"
              className="flex flex-col items-center p-10 rounded-2xl text-center cursor-pointer transition-transform hover:scale-[1.03] h-full"
              style={{
                background: '#fff',
                border: '2px solid rgba(90,158,111,0.3)',
              }}
            >
              <div
                className="mb-6 flex items-center justify-center w-20 h-20 rounded-full"
                style={{ background: '#f2f8f4' }}
              >
                <span className="flex items-center justify-center w-11 h-11">
                  <i className="ri-mail-fill text-[#5a9e6f] text-4xl"></i>
                </span>
              </div>
              <h3 style={{ color: '#8b4513', fontSize: '20px', marginBottom: '16px' }}>
                フォームでのお問い合わせ
              </h3>
              <span
                className="inline-block px-6 py-3 rounded-full font-bold"
                style={{
                  background: '#5a9e6f',
                  color: '#fff',
                  fontSize: '18px',
                }}
              >
                フォームを開く ↓
              </span>
              <p className="mt-4" style={{ color: '#6b5a4e', fontSize: '15px', lineHeight: '1.8' }}>
                24時間いつでも送信できます。<br />
                営業日中にご返信いたします。
              </p>
            </a>
          </FadeInSection>
        </div>
      </div>
    </section>
  );
}
